<template>
  <md-app md-waterfall md-mode="fixed">
    <md-app-toolbar md-elevation="4" class="u-fixed md-dense">
      <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
        <md-icon>menu</md-icon>
      </md-button>
      <topbarmenu :show-links="['overview']"></topbarmenu>
    </md-app-toolbar>
    <md-app-drawer :md-active.sync="menuVisible">
      <drawermenu></drawermenu>
    </md-app-drawer>
    <md-app-content class="c-login" v-show="isCookieConsented">
      <branding class="small"></branding>
      <md-subheader>Account</md-subheader>
      <p class="u-txt-centered" v-show="!isKnownUser">
        Je bent op dit moment niet ingelogd. De ingevoerde gegevens worden alleen in deze browser op dit apparaat opgeslagen. Als je je gegevens ook vanaf
        andere devices wilt kunnen benaderen, maak dan een account aan.
      </p>

      <authenticate :bind-auth-ui="!disableLoginPopup"></authenticate>

      <md-subheader>Privacy</md-subheader>
      <p>
        Voor deze webapp maken wij gebruik van cookies. Deze zijn onmisbaar voor de functionaliteit die wij aanbieden. Lees meer over cookies en hoe we met jouw
        gegevens omgaan in ons <a href="/privacy">privacy & cookie beleid</a>
      </p>

      <md-subheader>Instellingen</md-subheader>
      <p>
        Als je niet langer gebruik wilt maken van onze diensten op deze site, kun je eenvoudig je gegevens verwijderen van onze database (en je account
        opzeggen).
      </p>
      <p>LET OP: Dit kan niet teruggedraaid worden.</p>
      <md-button @click="checkDeletion = true">reset data</md-button>
      <md-dialog-confirm
        :md-active.sync="checkDeletion"
        md-title="Account opheffen"
        md-content="Je staat op het punt je account en alle gegevens te verwijderen, dit kan niet ongedaan worden. Weet je het zeker?"
        md-confirm-text="Ja"
        md-cancel-text="Oops, toch niet"
        @md-cancel="cancelDeletionHandle"
        @md-confirm="confirmDeletionHandle"
      >
      </md-dialog-confirm>
    </md-app-content>
  </md-app>
</template>

<script>
import { mapGetters } from "vuex";

import drawermenu from "./partials/MenuDrawer";
import topbarmenu from "./partials/MenuTopbar";
import branding from "./partials/Branding";
import authenticate from "./partials/Authenticate";
import { authUi } from "../init/firebase.init";

import { navigate, translate, googleTags } from "../mixins";
/* eslint no-debugger: 0 */
export default {
  name: "Account",
  mixins: [navigate, translate, googleTags],
  components: {
    drawermenu,
    topbarmenu,
    branding,
    authenticate
  },
  mounted() {
    this.gTagScreenView("Account");
  },
  data() {
    return {
      menuVisible: false,
      checkDeletion: false
    };
  },
  computed: {
    ...mapGetters(["isKnownUser", "isCookieConsented"]),
    disableLoginPopup() {
      return authUi.isPendingRedirect() || this.isCookieConsented;
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch("logout");
    },
    cancelDeletionHandle() {
      this.checkDeletion = false;
    },
    confirmDeletionHandle() {
      this.$store.dispatch("deleteUser").then(() => this.$store.dispatch("logout").then(() => this.gTagEvent("reset_data")));
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.c-login {
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
}

h1 {
  font-family: "Rajdhani", "Roboto", sans-serif;
  font-size: 3rem;
  font-weight: 300;
  margin-top: 0;
}

h2 {
  font-family: "Dawning of a New Day", cursive;
  font-size: 2rem;
  text-align: right;
}
p {
  padding: 0 16px;
}

.md-content .md-button:last-of-type {
  margin-bottom: 100px;
}
</style>
